<template>
  <span>
    <v-toolbar dense
               fixed>
      <v-btn router
             flat
             to="/viewfreight"
             class="teal--text darken-2">Kangaruu</v-btn>
      <v-spacer></v-spacer>

      <v-btn class="teal--text darken-2"
             small
             router
             flat
             icon
             v-on:click="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>

      <v-btn small
             flat
             icon
             router
             color="teal"
             @click.native="showHelp = true">
        <v-icon>help</v-icon>
      </v-btn>

    </v-toolbar>
    <v-layout wrap>
      <v-flex xs12
              sm6
              offset-sm3>
        <v-toolbar class="teal">
          <v-toolbar-title class="white--text">
            <broker-name v-if="toggle"
                         :brokerID="shipment.Shipper"></broker-name>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small
                 flat
                 icon
                 v-on:click.native="$router.push({ name: 'viewfreight' })"
                 color="white">
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>

        </v-toolbar>
        <v-card>
          <div class="google-maps">
            <iframe :src="googleUrl"
                    width="400"
                    height="300"
                    frameborder="0"
                    style="border:0"></iframe>
          </div>
          <v-divider></v-divider>

          <v-card>
            <v-card-text>
              <v-container>
                <form @submit.prevent="saveQuote">
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field :label="shippingLabel"
                                    v-model="shippingQuote"
                                    required
                                    prepend-icon="attach_money"></v-text-field>
                    </v-flex>
                    <v-snackbar :timeout="4000"
                                v-model="snackbar">
                      Rate Has Been Updated!
                      <v-btn dark
                             flat
                             @click.native="snackbar = false">Close</v-btn>
                    </v-snackbar>
                  </v-layout>
                  <v-btn outline
                         color="green"
                         type="submit">Save</v-btn>
                </form>
              </v-container>
            </v-card-text>
          </v-card>
          <v-divider></v-divider>

          <chat :messages="messages"
                :onSend="onSend"></chat>

          <v-divider>
          </v-divider>

          <waybill :freightID="shipmentID"
                   :isBroker="true"
                   :brokerID="brokerID"
                   v-on:printWaybill="print()"
                   id="my-node"></waybill>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn icon
                     small
                     flat
                     slot="activator"
                     @click.native="warnDialog=true">
                <v-icon color="teal">remove_circle_outline</v-icon>
              </v-btn>
              <span>Decline Shipment</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn v-if="quote.selected && !imageURL === ''"
                     icon
                     small
                     flat
                     slot="activator"
                     v-on:click.native="$router.push({ name: 'viewimages', params: { freightID: freightID, imageURL: imageURL, isBroker: true, imageName: shipment.File } })">
                <v-icon color="teal">attach_file</v-icon>
              </v-btn>
              <span>DownLoad Bill Of Lading</span>
            </v-tooltip>
          </v-card-actions>

        </v-card>
      </v-flex>

      <v-layout row
                justify-center>
        <v-dialog v-model="warnDialog"
                  persistent
                  max-width="290">
          <v-card>
            <v-card-title class="headline">Decline this Shipment?</v-card-title>
            <v-card-text>Declining a shipment will remove it from your active shipments.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1"
                     flat
                     @click.native="warnDialog = false">Disagree</v-btn>
              <v-btn color="green darken-1"
                     flat
                     @click.native="removeShipment()">Agree</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

    </v-layout>

    <v-dialog v-model="showImage"
              max-width="200">
      <v-card v-on:closeImage="showImage=false">
        <v-card-title>Available Images</v-card-title>
        <v-list>
          <v-list-tile>
            <a :href="imageURL">
              {{shipment.File}}
            </a>
          </v-list-tile>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon
                 v-on:click="showImage=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-dialog v-model="showHelp">
      <v-card>
        <help></help>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey"
                 flat
                 outline
                 @click.native="showHelp = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </span>

</template>

<script>
import db from './fireBaseInit'
import waybill from './WayBill'
import chat from './Chat'
import Firebase from 'firebase'
import moment from 'moment'
import brokerName from './BrokerName'
import printJS from 'print-js'
import help from '@/components/DetailHelp'

export default {
  components: { waybill, brokerName, chat, help },
  props: ['shipmentID', 'brokerID'],
  name: 'brokerfreightdetail',
  data () {
    return {
      shipment: {},
      googleUrl: null,
      dialog: false,
      shippingQuote: null,
      messages: [],
      snackbar: false,
      toggle: false,
      warnDialog: false,
      quote: {},
      freightID: '',
      showImage: false,
      showHelp: false,
      imageURL: '',
      shippingLabel: 'Shipping Quote'
    }
  },
  watch: {
  },
  computed: {
  },
  mounted: function () {
    this.$bind('shipment', db.collection('freight').doc(this.shipmentID))
      .then((doc) => {
        if (doc.brokers[Firebase.auth().currentUser.uid] === true) {
          this.freightID = this.shipmentID
          this.getMap()
          this.clearMessageFlag()
          this.imageURL = this.shipment.BOL
          this.shippingLabel = this.shipment.Equipment + ' Quote'
        } else {
          alert('Cannot Access this Shipment')
          this.shipment = 'Invalid'
          this.freightID = 'Invalid'
        }
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  },
  methods: {
    print: function () {
      printJS({ printable: 'my-node', type: 'html', documentTitle: 'Kangaruu - Shipping Instructions' })
    },
    getMap: function () {
      this.toggle = true
      if (typeof this.shipment !== 'undefined' && this.shipment) {
        var start = this.shipment.Pickup[0]
        var end = this.shipment.Delivery[this.shipment.Delivery.length - 1]
        var points = ''
        for (let i = 1; i < this.shipment.Pickup.length; i++) {
          let str = this.shipment.Pickup[i]
          points = points + str.replace(/ /g, '+') + '| '
        }
        for (let i = 0; i < this.shipment.Delivery.length; i++) {
          let str = this.shipment.Delivery[i]
          points = points + str.replace(/ /g, '+') + '| '
        }
        points = points.substring(0, points.length - 2)

        this.googleUrl = `https://www.google.com/maps/embed/v1/directions?key=AIzaSyCw3FKI8Eh1SY6rfwJkba1LL3Aetx9RrvI&origin=${start}&destination=${end}&waypoints=${points}`
      }
    },
    downLoadFile () {
      var fileName = this.shipment.File
      var xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function (event) {
        var blob = new Blob([xhr.response], { type: 'image/png' })
        console.log(xhr.response)
        let a = document.createElement('a')
        a.style = 'display: none'
        document.body.appendChild(a)
        // Create a DOMString representing the blob
        // and point the link element towards it
        let url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = fileName
        // programatically click the link to trigger the download
        a.click()
        // release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url)
      }
      xhr.open('GET', this.shipment.BOL)
      xhr.send()
    },
    saveQuote: function () {
      var quote = Number(this.shippingQuote)
      if (quote > 0) {
        var num = '$' + quote.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        var msg = {}
        msg['quote'] = num
        msg['status'] = 'Quoted'
        this.onSend(`New Rate - ${num}`)
        db.collection('conversations').doc(this.freightID).collection('brokers').doc(Firebase.auth().currentUser.uid).update(msg)
        this.shippingQuote = ''
        this.snackbar = true
        // create rate record
        var rate = {}
        if (this.shipment.City) {
          rate['city'] = this.shipment.City
        }
        if (this.shipment.Miles) {
          rate['miles'] = this.shipment.Miles
        }
        rate['quote'] = quote
        rate['type'] = this.shipment.Equipment
        rate['shipment'] = this.shipmentID
        rate['date'] = moment().unix()
        db.collection('rates').add(rate)

        // Update quoteCount
        const senderRef = db.collection('users').doc(Firebase.auth().currentUser.uid)
        return senderRef.get().then(snap => {
          var quoteCount = snap.data().quoteCount + 1
          if (isNaN(quoteCount)) { quoteCount = 1 }
          const data = { quoteCount }
          return senderRef.update(data)
        })
      } else { alert('Quote must be a real dollar amount.') }
    },
    onSend (message) {
      var msg = {}
      msg['message'] = message
      msg['sender'] = Firebase.auth().currentUser.uid
      msg['created'] = moment().unix()
      db.collection('conversations').doc(this.freightID).collection('brokers').doc(Firebase.auth().currentUser.uid).collection('messages').add(msg)

      // update freight to new message
      var userList = this.shipment.newMessages
      var messages = {}
      userList[this.shipment.Shipper] = true
      messages['newMessages'] = userList
      db.collection('freight').doc(this.freightID).update(messages)
      // update Broker to new message
      var newMsg = {}
      newMsg['newMessage'] = true
      db.collection('conversations').doc(this.freightID).collection('brokers').doc(Firebase.auth().currentUser.uid).update(newMsg)

      // send push to shipper
      db.collection('users').doc(this.shipment.Shipper).get().then((snap) => {
        if (snap.data().sendPush) {
          db.collection('push').add({ sendTo: `${this.shipment.Shipper}` })
        }
      })
    },
    logout: function () {
      Firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    },
    clearMessageFlag: function () {
      var userList = {}
      userList = this.shipment.newMessages
      var messages = {}
      userList[Firebase.auth().currentUser.uid] = false
      messages['newMessages'] = userList
      db.collection('freight').doc(this.freightID).update(messages)
    },
    removeShipment: function () {
      var userList = {}
      userList = this.shipment.brokers
      var brokers = {}
      userList[Firebase.auth().currentUser.uid] = false
      brokers['brokers'] = userList
      console.log(brokers)
      db.collection('freight').doc(this.freightID).update(brokers)
      db.collection('conversations').doc(this.freightID).collection('brokers').doc(Firebase.auth().currentUser.uid).update({ isActive: false })
      this.$router.replace({ path: '/viewfreight' })
    }
  },
  firestore () {
    return {
      shipment: db.collection('freight').doc(this.shipmentID),
      messages: db.collection('conversations').doc(this.shipmentID).collection('brokers').doc(Firebase.auth().currentUser.uid).collection('messages').orderBy('created'),
      quote: db.collection('conversations').doc(this.shipmentID).collection('brokers').doc(Firebase.auth().currentUser.uid)
    }
  }
}
</script>

<style>
.google-maps {
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
}
.google-maps iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}

/* Shipping List */
#sList {
  font-family: 'Courier New', Courier, monospace;
}
</style>


// WEBPACK FOOTER //
// src/components/BrokerFreightDetail.vue